import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { whatsappUrl } from "../../lib/email";

// Premium sticky booking bar - appears after scrolling past hero
const StickyBookNow = ({ thresholdPx = 600 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > thresholdPx);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [thresholdPx]);

  // Optimized WhatsApp pre-filled message
  const whatsappMessage = `Hello GlowLAWNS Team,
I would like to check availability and packages for Moonrise Valley.
Please assist me with details.`;

  if (!show) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-3 md:p-4 bg-gradient-to-t from-black/95 via-black/90 to-transparent backdrop-blur-sm"
      data-testid="sticky-book-now"
    >
      <div className="mx-auto flex max-w-2xl items-center justify-center gap-3">
        {/* Primary CTA - Book Now */}
        <Link
          to="/contact"
          className="flex-1 max-w-xs rounded-xl bg-[#C9A227] px-6 py-3.5 text-center text-sm md:text-base font-semibold text-[#111] shadow-[0_10px_40px_rgba(201,162,39,0.3)] hover:bg-[#d4b03a] hover:-translate-y-0.5 transition-all duration-300"
          data-testid="sticky-book-now-btn"
        >
          Book Now
        </Link>
        
        {/* WhatsApp Instant Booking - Mobile prominent */}
        <a
          href={whatsappUrl(whatsappMessage)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 px-4 md:px-5 py-3.5 rounded-xl bg-green-600/20 border border-green-500/30 text-green-400 hover:bg-green-600/30 transition-all duration-300"
          data-testid="sticky-whatsapp-btn"
          aria-label="Instant Booking Assistance"
        >
          <MessageCircle className="w-5 h-5" />
          <span className="hidden md:inline text-sm font-medium">Instant Booking</span>
        </a>
      </div>
    </div>
  );
};

export default StickyBookNow;
